"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _isValidI18nKey = _interopRequireDefault(require("I18n/utils/isValidI18nKey"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _HR = _interopRequireDefault(require("UIComponents/elements/HR"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H6"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _MerchandiseIdBillingNameKeyMap = _interopRequireDefault(require("self-service-api/constants/MerchandiseIdBillingNameKeyMap"));

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _merchUtils = require("self-service-api/core/utilities/merchUtils");

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _PriceBreakdownRow = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/PriceBreakdownRow"));

var _PriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/pricing/PriceDisplay"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _CurrentSubscriptionsSelectors = require("pricing-pages-unified-ui/selectors/CurrentSubscriptionsSelectors");

var _PricingSelectors = require("pricing-pages-unified-ui/selectors/PricingSelectors");

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _MerchandiseIdLists = require("self-service-api/constants/MerchandiseIdLists");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _H2 = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _ItemConfigsSelectors = require("../../selectors/ItemConfigsSelectors");

var _Terms = require("self-service-api/constants/Terms");

var _PricingSelectors2 = require("../../selectors/PricingSelectors");

var _utils = require("./utils");

var _PromotionSelectors2 = require("../../selectors/PromotionSelectors");

var _colors = require("HubStyleTokens/colors");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

var _ContactsSelectors = require("../../selectors/ContactsSelectors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 0 25px 10px 25px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MODAL_WIDTH = 600;

var getSum = function getSum(a, b) {
  return a + b;
};

var ModalBody = _styledComponents.default.div.withConfig({
  displayName: "BundlePricingBreakdownModal__ModalBody",
  componentId: "sc-1vjuvxq-0"
})(_templateObject());

var _getLang = function _getLang(path) {
  return _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator." + path
  });
};

var BundlePricingBreakdownModal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(BundlePricingBreakdownModal, _React$Component);

  function BundlePricingBreakdownModal() {
    (0, _classCallCheck2.default)(this, BundlePricingBreakdownModal);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BundlePricingBreakdownModal).apply(this, arguments));
  }

  (0, _createClass2.default)(BundlePricingBreakdownModal, [{
    key: "getDefaultTermForMerch",
    value: function getDefaultTermForMerch(merchId) {
      var availableTerms = this.props.getAvailableTerms(merchId);
      return availableTerms.monthly ? _Terms.MONTHLY : _Terms.ANNUAL;
    }
  }, {
    key: "getAdditionalUnitPricePerMonth",
    value: function getAdditionalUnitPricePerMonth(merchId, activeCurrencyCode) {
      var _this$props = this.props,
          getAdditionalContactsUnitPrice = _this$props.getAdditionalContactsUnitPrice,
          getAdditionalUsersUnitPrice = _this$props.getAdditionalUsersUnitPrice,
          isInMCBeta = _this$props.isInMCBeta,
          getQuantityMultiplier = _this$props.getQuantityMultiplier;

      var isContactsBased = _MerchandiseIdLists.CONTACT_BASED_MERCHANDISE_IDS.includes(merchId);

      var term = this.getDefaultTermForMerch(merchId);
      var price = isContactsBased ? getAdditionalContactsUnitPrice(merchId, term) : getAdditionalUsersUnitPrice(merchId, term);
      var message;

      if (isContactsBased && isInMCBeta) {
        // TODO: once translations for additionalContactsV2_jsx come in, we can delete this block of logic and replace additonalContacts_jsx usage with additionalContactsV2_jsx altogether
        var quantityMultiplier = getQuantityMultiplier(merchId);
        message = _react.default.createElement(_FormattedJSXMessage.default, {
          message: "pricingPage.calculator.priceBreakdown.perAdditionalUnitSubtext.additionalContactsV2_jsx",
          elements: {
            Price: _PriceDisplay.default,
            Number: _FormattedNumber.default
          },
          options: {
            priceProps: {
              price: price,
              currencyCode: activeCurrencyCode
            },
            numberProps: {
              value: quantityMultiplier
            }
          }
        });
      } else {
        var langPath = isContactsBased ? 'additionalContacts_jsx' : 'additionalUsers_jsx';
        message = _react.default.createElement(_FormattedJSXMessage.default, {
          message: "pricingPage.calculator.priceBreakdown.perAdditionalUnitSubtext." + langPath,
          options: {
            price: price,
            currencyCode: activeCurrencyCode
          },
          elements: {
            PriceDisplay: _PriceDisplay.default,
            FormattedNumber: _FormattedNumber.default
          }
        });
      }

      return _react.default.createElement(_Small.default, {
        use: "help"
      }, message);
    }
  }, {
    key: "getAdjustedQuantity",
    value: function getAdjustedQuantity(merchId) {
      var _this$props2 = this.props,
          _this$props2$bundleSe = _this$props2.bundleSelections,
          marketingPlanSelected = _this$props2$bundleSe.marketingPlanSelected,
          marketingUnits = _this$props2$bundleSe.marketingUnits,
          salesPlanSelected = _this$props2$bundleSe.salesPlanSelected,
          salesUnits = _this$props2$bundleSe.salesUnits,
          servicePlanSelected = _this$props2$bundleSe.servicePlanSelected,
          serviceUnits = _this$props2$bundleSe.serviceUnits,
          products = _this$props2.products;
      var merchObj = products[merchId];
      var includedAdditionalUnits = merchObj.includedAdditionalUnits;

      if (merchId === marketingPlanSelected) {
        return (0, _merchUtils.getAdditionalUnitsQuantityMinusIncluded)(products, marketingUnits, merchId);
      }

      if (merchId === salesPlanSelected) {
        return salesUnits;
      }

      if (merchId === servicePlanSelected) {
        return serviceUnits;
      }

      return includedAdditionalUnits;
    }
  }, {
    key: "getDiscountSubtext",
    value: function getDiscountSubtext(merchId) {
      var _this$props3 = this.props,
          isGrowthSuite = _this$props3.isGrowthSuite,
          growthSuiteDiscount = _this$props3.growthSuiteDiscount,
          products = _this$props3.products;

      if (isGrowthSuite && !(0, _utils.isMerchInGrowthSuite)(merchId) && !products[merchId].service) {
        // Currently the string is hardcoded to discuss the 25% discount
        // When translations are done, change the copy to reference discountedWithGrowthSuiteSubtext
        // so we can generalize this subtext to apply to all discount numbers
        if (growthSuiteDiscount === 25) {
          return _react.default.createElement(_Small.default, {
            style: {
              color: _colors.OZ_DARK
            }
          }, _react.default.createElement(_FormattedMessage.default, {
            message: "pricingPage.pages.growthSuite.discountedAddonsSubtext"
          }));
        }
      }

      return null;
    }
  }, {
    key: "getPriceSubtext",
    value: function getPriceSubtext(eligiblePromotions) {
      var merchId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var availableTerms = this.props.getAvailableTerms(merchId);
      var activeTerm = availableTerms.monthly ? _Terms.MONTHLY : _Terms.ANNUAL;
      return _react.default.createElement(_Small.default, {
        use: "help"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "pricingPage.calculator.priceBreakdown.priceSubtextParentheses." + activeTerm
      }));
    }
  }, {
    key: "getBillingName",
    value: function getBillingName(merchId) {
      var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var billingNameKey = _MerchandiseIdBillingNameKeyMap.default[merchId]; // Note: quantity may not always be used in the billingNameKey string,
      //       but there should always be a quantity we can pass

      return _react.default.createElement(_FormattedMessage.default, {
        message: "pricing-pages.billingNames." + billingNameKey,
        options: {
          count: quantity
        }
      });
    }
  }, {
    key: "getProductDescriptionSubtext",
    value: function getProductDescriptionSubtext(merchId) {
      var billingNameKey = _MerchandiseIdBillingNameKeyMap.default[merchId];
      var message = "pricingPage.calculator.priceBreakdown.onboardingValueProps." + billingNameKey;
      if ((0, _isValidI18nKey.default)(message)) return _react.default.createElement(_Small.default, {
        use: "help",
        style: {
          fontStyle: 'italic'
        }
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: message
      }));
      return undefined;
    }
  }, {
    key: "getCostToGetStarted",
    value: function getCostToGetStarted() {
      var _this$props4 = this.props,
          oneTimeFees = _this$props4.oneTimeFees,
          recurringFees = _this$props4.recurringFees,
          getAvailableTerms = _this$props4.getAvailableTerms;
      var oneTimeCost = oneTimeFees.map(function (fee) {
        return fee.calculatedPrice;
      }).reduce(getSum, 0);
      var firstTimeRecurringCost = recurringFees.map(function (fee) {
        var availableTerms = getAvailableTerms(fee.merchId);
        return availableTerms.monthly ? fee.monthly.calculatedPrice : fee.anually.calculatedPrice;
      }).reduce(getSum, 0);
      return oneTimeCost + firstTimeRecurringCost;
    }
  }, {
    key: "renderMonthlyFees",
    value: function renderMonthlyFees() {
      var _this = this;

      var _this$props5 = this.props,
          monthlyFees = _this$props5.monthlyFees,
          activeCurrencyCode = _this$props5.activeCurrencyCode,
          eligiblePromotions = _this$props5.eligiblePromotions;
      return monthlyFees.map(function (recurringMerch) {
        var productMerch = recurringMerch.priceBreakdown[0];
        var additionalUnitMerch = recurringMerch.priceBreakdown.length > 1 ? recurringMerch.priceBreakdown[1] : null;

        var adjustedQuantity = _this.getAdjustedQuantity(productMerch.merchandiseId);

        return recurringMerch.calculatedPrice !== 0 ? _react.default.createElement(_react.default.Fragment, {
          key: productMerch.merchandiseId
        }, _react.default.createElement(_PriceBreakdownRow.default, {
          price: productMerch.calculatedPrice,
          currencyCode: activeCurrencyCode,
          priceDisclaimer: _this.getPriceSubtext(eligiblePromotions, productMerch.merchandiseId),
          text: _this.getBillingName(productMerch.merchandiseId, adjustedQuantity),
          isMonthly: true,
          subtext: _this.getDiscountSubtext(productMerch.merchandiseId)
        }), additionalUnitMerch && !!adjustedQuantity && _react.default.createElement(_PriceBreakdownRow.default, {
          price: additionalUnitMerch.calculatedPrice,
          currencyCode: activeCurrencyCode,
          priceDisclaimer: _this.getPriceSubtext(eligiblePromotions, productMerch.merchandiseId),
          text: _this.getBillingName(additionalUnitMerch.merchandiseId, adjustedQuantity),
          isMonthly: true,
          subtext: _this.getAdditionalUnitPricePerMonth(productMerch.merchandiseId, activeCurrencyCode)
        })) : null;
      });
    }
  }, {
    key: "renderOneTimeFee",
    value: function renderOneTimeFee(oneTimeFee) {
      var oneTimeFeePrice = oneTimeFee.calculatedPrice;
      var merchId = oneTimeFee.priceBreakdown[0].merchandiseId;
      var activeCurrencyCode = this.props.activeCurrencyCode;
      var isBuyingNov2019Onboarding = merchId === _MerchandiseIds.SERVICE_SALES_PROFESSIONAL_ONBOARDING_NOV_2019 || merchId === _MerchandiseIds.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING_NOV_2019;
      return _react.default.createElement(_PriceBreakdownRow.default, {
        key: merchId,
        price: oneTimeFeePrice,
        currencyCode: activeCurrencyCode,
        priceDisclaimer: _react.default.createElement(_Small.default, {
          use: "help"
        }, // Hacky 11/1 logic to show the promotional subtext only for the discounted onboarding SKUs
        isBuyingNov2019Onboarding ? _react.default.createElement("div", null, _react.default.createElement(_FormattedMessage.default, {
          message: "pricingPage.calculator.priceBreakdown.fiftyPercentPromoSubtext"
        }), _react.default.createElement("br", null)) : null, _react.default.createElement(_FormattedMessage.default, {
          message: "pricingPage.notes.oneTimeFeeParentheses"
        })),
        text: this.getBillingName(merchId),
        subtext: this.getProductDescriptionSubtext(merchId)
      });
    }
  }, {
    key: "renderOneTimeFees",
    value: function renderOneTimeFees() {
      var _this2 = this;

      var oneTimeFees = this.props.oneTimeFees;
      return _react.default.createElement("div", {
        className: "m-top-9"
      }, _react.default.createElement(_H.default, {
        className: "text-left m-left-7 m-bottom-7"
      }, _getLang('priceBreakdown.oneTimeFees')), oneTimeFees.filter(function (fee) {
        return fee.priceBreakdown.length;
      }).map(function (fee) {
        return _this2.renderOneTimeFee(fee);
      }));
    }
  }, {
    key: "renderTotalCosts",
    value: function renderTotalCosts() {
      var _this$props6 = this.props,
          activeCurrencyCode = _this$props6.activeCurrencyCode,
          totalPrice = _this$props6.totalPrice;
      return _react.default.createElement("div", {
        style: {
          width: '100%'
        }
      }, _react.default.createElement(_PriceBreakdownRow.default, {
        text: _getLang('priceBreakdown.monthlyCost'),
        price: totalPrice.monthly.calculatedPrice,
        fullPrice: totalPrice.monthly.fullPrice,
        currencyCode: activeCurrencyCode,
        isMonthly: true,
        isTotal: true
      }), _react.default.createElement(_PriceBreakdownRow.default, {
        text: _getLang('priceBreakdown.oneTimeFees'),
        price: totalPrice.oneTimeFee.calculatedPrice,
        fullPrice: totalPrice.oneTimeFee.fullPrice,
        currencyCode: activeCurrencyCode,
        isTotal: true
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          onCloseClick = _this$props7.onCloseClick,
          oneTimeFees = _this$props7.oneTimeFees;
      return _react.default.createElement(_UIModal.default, {
        use: "conversational",
        width: MODAL_WIDTH
      }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: onCloseClick
      }), _react.default.createElement(_H2.default, {
        className: "m-bottom-10"
      }, _getLang('priceBreakdown.modal'))), _react.default.createElement(ModalBody, null, _react.default.createElement(_H.default, {
        className: "text-left m-left-7 m-bottom-0"
      }, _getLang('priceBreakdown.recurringFees')), this.renderMonthlyFees(), oneTimeFees && this.renderOneTimeFees(), _react.default.createElement(_HR.default, null), this.renderTotalCosts(), _react.default.createElement("div", {
        className: "p-all-7 text-center"
      }, _react.default.createElement(_Small.default, {
        use: "help"
      }, _getLang('priceBreakdown.footerModal')))));
    }
  }]);
  return BundlePricingBreakdownModal;
}(_react.default.Component);

BundlePricingBreakdownModal.propTypes = {
  activeCurrencyCode: _propTypes.default.string.isRequired,
  getAdditionalContactsUnitPrice: _propTypes.default.func.isRequired,
  getAdditionalUsersUnitPrice: _propTypes.default.func.isRequired,
  bundleSelections: _propTypes.default.object.isRequired,
  onCloseClick: _propTypes.default.func.isRequired,
  eligiblePromotions: _propTypes.default.object.isRequired,
  products: _propTypes.default.object.isRequired,
  recurringFees: _propTypes.default.array.isRequired,
  monthlyFees: _propTypes.default.array.isRequired,
  oneTimeFees: _propTypes.default.array.isRequired,
  totalPrice: _propTypes.default.object.isRequired,
  getAvailableTerms: _propTypes.default.func.isRequired,
  isGrowthSuite: _propTypes.default.bool,
  growthSuiteDiscount: _propTypes.default.number,
  isInMCBeta: _propTypes.default.bool,
  getQuantityMultiplier: _propTypes.default.func
};

var mapStateToProps = function mapStateToProps(state, props) {
  var bundleSelections = props.bundleSelections;
  var merchandiseMap = (0, _MerchandiseSelectors.merchandiseSelector)(state);
  var getMultiplePriceBreakdowns = (0, _PricingSelectors2.getMultiplePriceBreakdownsSelector)(state);
  var allPriceBreakdowns = getMultiplePriceBreakdowns({
    bundleSelections: bundleSelections
  });
  return {
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    currentSubscriptions: (0, _CurrentSubscriptionsSelectors.currentSubscriptionsSelector)(state),
    eligiblePromotions: (0, _PromotionSelectors.allPromotionsSelector)(state),
    products: merchandiseMap,
    getAdditionalContactsUnitPrice: (0, _PricingSelectors.getAdditionalContactsMonthlyCostSelector)(state),
    getAdditionalUsersUnitPrice: (0, _PricingSelectors.getAdditionalSeatMonthlyCostSelector)(state),
    recurringFees: allPriceBreakdowns.filter(function (breakdown) {
      return breakdown.monthly.calculatedPrice !== 0;
    }).map(function (breakdown) {
      return {
        merchId: breakdown.monthly.priceBreakdown[0].merchandiseId,
        monthly: breakdown.monthly,
        annually: breakdown.annually
      };
    }),
    monthlyFees: allPriceBreakdowns.filter(function (breakdown) {
      return breakdown.monthly.calculatedPrice !== 0;
    }).map(function (breakdown) {
      return breakdown.monthly;
    }),
    oneTimeFees: allPriceBreakdowns.filter(function (breakdown) {
      return breakdown.oneTimeFee.calculatedPrice !== 0;
    }).map(function (breakdown) {
      return breakdown.oneTimeFee;
    }),
    getAvailableTerms: (0, _ItemConfigsSelectors.getAvailableTermsForMerchSelector)(state),
    isGrowthSuite: (0, _utils.isGrowthSuiteSelection)(bundleSelections, merchandiseMap),
    growthSuiteDiscount: (0, _PromotionSelectors2.growthSuiteDiscountSelector)(state),
    isInMCBeta: (0, _MarketingContactsSelectors.isInMCBetaSelector)(state),
    getQuantityMultiplier: function getQuantityMultiplier(merchId) {
      return (0, _ContactsSelectors.contactsQuantityMultiplierSelector)(state, merchId);
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(BundlePricingBreakdownModal);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/BundlePricingBreakdownModal.js
// module id = 710
// module chunks = 5 6